import { render, staticRenderFns } from "./OsComentarios.vue?vue&type=template&id=bae76058&"
import script from "./OsComentarios.vue?vue&type=script&lang=js&"
export * from "./OsComentarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports